export const STATUS_META = {
  open: { label: "Open", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  pending: { label: "Pending", cls: "bg-orange-100 text-orange-800 border-orange-300" },
  accepted: { label: "Accepted", cls: "bg-blue-100 text-blue-800 border-blue-300" },
  in_progress: { label: "In Progress", cls: "bg-indigo-100 text-indigo-800 border-indigo-300" },
  completed: { label: "Completed", cls: "bg-purple-100 text-purple-800 border-purple-300" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  paid: { label: "Paid", cls: "bg-emerald-600 text-white border-emerald-700" },
  disputed: { label: "Disputed", cls: "bg-red-100 text-red-800 border-red-300" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-600 border-slate-300" },
};

export const US_TIMEZONES = [
  ["America/New_York", "Eastern (New York)"],
  ["America/Chicago", "Central (Chicago)"],
  ["America/Denver", "Mountain (Denver)"],
  ["America/Phoenix", "Arizona (Phoenix, no DST)"],
  ["America/Los_Angeles", "Pacific (Las Vegas / Los Angeles)"],
  ["America/Anchorage", "Alaska"],
  ["Pacific/Honolulu", "Hawaii"],
];

export function jobTime(job) {
  if (!job?.starts_at_utc || !job?.timezone) return job?.time || "";
  try {
    return new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit", timeZone: job.timezone, timeZoneName: "short" })
      .format(new Date(job.starts_at_utc));
  } catch { return job.time; }
}

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-300" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wide border ${m.cls}`}
    >
      {m.label}
    </span>
  );
}

export function money(n) {
  return `$${Number(n || 0).toFixed(2)}`;
}

export const BG_META = {
  not_submitted: { label: "Not Submitted", cls: "bg-slate-100 text-slate-700" },
  pending: { label: "Pending Review", cls: "bg-amber-100 text-amber-800" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-800" },
  denied: { label: "Denied", cls: "bg-red-100 text-red-800" },
};
